import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

/**
 * Hook pour traduire les noms de catégories/sous-catégories par défaut.
 * Les catégories isDefault utilisent leur ID comme clé de traduction.
 * Les catégories personnalisées gardent leur nom tel quel.
 */
export function useCategoryTranslation() {
  const { t } = useTranslation('categories');

  const translateCategoryName = useCallback(
    (id: string, name: string, isDefault?: boolean): string => {
      if (isDefault === false) return name;
      const translated = t(`defaults.${id}`, { defaultValue: '' });
      return translated || name;
    },
    [t]
  );

  return { translateCategoryName };
}
